import React from 'react';

// Types
import { ReactionType } from './types';

// Components
import WpEmoji from '../emoji/WpEmoji';
import { WpAvatar } from '../avatar';

// Styles
import './ReactionPopover.scss';

type Props = {
  emoji: string;
  _reactions: ReactionType[];
  users?: any;
};

const ReactionPopover = ({ emoji, _reactions, users }: Props) => {
  const reactions = _reactions.filter(r => r.data === emoji);

  const baseClassName = 'ReactionPopover';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__title`}>
        <WpEmoji emoji={emoji} />
        <span className={`${baseClassName}__title__label`}>{emoji}</span>
      </div>
      <div className={`${baseClassName}__user-list`}>
        {reactions.map(r => {
          const user = users.find(u => u.id === r.userId);
          if (!user) return null;
          return (
            <div key={user.id} className={`${baseClassName}__user-list__user`}>
              <WpAvatar size="sm" avatar={user.avatar} />
              <span className={`${baseClassName}__user-list__user__name`}>
                {user.displayName || user.fullName || user.email}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReactionPopover;
